import type { ComputedRef } from 'vue';
import { getEntrySearchForAttribution } from '../../common/entryContext';
import type { TrackingParams } from './types';

const URL = '/track';

const stripLeadingQuestionMark = (search: string): string => {
  return search.startsWith('?') ? search.slice(1) : search;
};

const removeParam = (key: string, sourceURL: string): string => {
  const [urlBase, queryString] = sourceURL.split('?');
  if (!queryString) {
    return sourceURL;
  }
  const params = queryString
    .split('&')
    .filter(param => !param.startsWith(`${key}=`))
    .join('&');
  return `${urlBase}?${params}`;
};

export const getTrackingParams = (
  rtkfbp: string | undefined,
  rtkfbc: string | undefined,
): TrackingParams => {
  const entrySearch = getEntrySearchForAttribution();
  const searchForParams = entrySearch || globalThis.location.search;
  const searchQs = stripLeadingQuestionMark(searchForParams);
  const urlParams = new URLSearchParams(searchQs);
  const pixelParams = (searchQs ? `&${searchQs}` : '')
    + `&sub19=${encodeURIComponent(rtkfbp ?? '')}&sub20=${encodeURIComponent(rtkfbc ?? '')}`;

  return {
    urlParams,
    pixelParams,
  };
};

export const buildInitialUrl = (
  campaignID: string,
  referrer: string,
  experimentId: ComputedRef<string | undefined>,
  variation: ComputedRef<string | undefined>,
): string => {
  let initialSrc = `${URL}/${campaignID}?format=json&referrer=${encodeURIComponent(referrer)}`;
  if (experimentId.value && variation.value) {
    initialSrc = `${initialSrc}&experiment=${experimentId.value}&variation=${variation.value}`;
  }

  for (let i = 1; i <= 10; i++) {
    initialSrc = removeParam(`sub${i}`, initialSrc);
  }
  initialSrc = removeParam('cost', initialSrc);
  initialSrc = removeParam('ref_id', initialSrc);

  return initialSrc;
};
